import React, { createContext, useContext, useState, useEffect } from 'react';

const EventosContext = createContext();

// Dados iniciais dos convidados (lista totalmente ficticia)
const CONVIDADOS_INICIAIS = [
  {responsavel: "FAMILIA ALMEIDA", nome: "MARCOS ALMEIDA", tipo: "Adulto", contato: "(21) 98811-2201", data: "08/10/2026", idade: 41},
  {responsavel: "FAMILIA ALMEIDA", nome: "LIVIA ALMEIDA", tipo: "Adulto", contato: "(21) 98811-2201", data: "08/10/2026", idade: 38},
  {responsavel: "FAMILIA ALMEIDA", nome: "PEDRO ALMEIDA", tipo: "Criança", contato: "(21) 98811-2201", data: "08/10/2026", idade: 11},
  {responsavel: "FAMILIA BRAGA", nome: "ROBERTO BRAGA", tipo: "Adulto", contato: "(21) 97744-1020", data: "10/10/2026", idade: 36},
  {responsavel: "FAMILIA BRAGA", nome: "NATALIA BRAGA", tipo: "Adulto", contato: "(21) 97744-1020", data: "10/10/2026", idade: 34},
  {responsavel: "FAMILIA BRAGA", nome: "SOFIA BRAGA", tipo: "Criança", contato: "(21) 97744-1020", data: "10/10/2026", idade: 7},
  {responsavel: "FAMILIA COSTA", nome: "TIAGO COSTA", tipo: "Adulto", contato: "(21) 96500-8808", data: "12/10/2026", idade: 32},
  {responsavel: "FAMILIA COSTA", nome: "RENATA COSTA", tipo: "Adulto", contato: "(21) 96500-8808", data: "12/10/2026", idade: 31},
  {responsavel: "FAMILIA COSTA", nome: "LARA COSTA", tipo: "Criança", contato: "(21) 96500-8808", data: "12/10/2026", idade: 6},
  {responsavel: "FAMILIA DUARTE", nome: "GUILHERME DUARTE", tipo: "Adulto", contato: "(22) 98123-4432", data: "14/10/2026", idade: 29},
  {responsavel: "FAMILIA DUARTE", nome: "CAMILA DUARTE", tipo: "Adulto", contato: "(22) 98123-4432", data: "14/10/2026", idade: 28},
  {responsavel: "FAMILIA DUARTE", nome: "ENZO DUARTE", tipo: "Criança", contato: "(22) 98123-4432", data: "14/10/2026", idade: 5},
  {responsavel: "FAMILIA ESTEVES", nome: "JOAO ESTEVES", tipo: "Adulto", contato: "(21) 97301-2209", data: "15/10/2026", idade: 45},
  {responsavel: "FAMILIA ESTEVES", nome: "MARTA ESTEVES", tipo: "Adulto", contato: "(21) 97301-2209", data: "15/10/2026", idade: 42},
  {responsavel: "FAMILIA FARIAS", nome: "LEONARDO FARIAS", tipo: "Adulto", contato: "(21) 99145-7803", data: "17/10/2026", idade: 33},
  {responsavel: "FAMILIA FARIAS", nome: "PRISCILA FARIAS", tipo: "Adulto", contato: "(21) 99145-7803", data: "17/10/2026", idade: 30},
  {responsavel: "FAMILIA FARIAS", nome: "MANUELA FARIAS", tipo: "Criança", contato: "(21) 99145-7803", data: "17/10/2026", idade: 9},
  {responsavel: "FAMILIA GOMES", nome: "SERGIO GOMES", tipo: "Adulto", contato: "(21) 99905-6614", data: "18/10/2026", idade: 39},
  {responsavel: "FAMILIA GOMES", nome: "DANIELA GOMES", tipo: "Adulto", contato: "(21) 99905-6614", data: "18/10/2026", idade: 37},
  {responsavel: "FAMILIA GOMES", nome: "HEITOR GOMES", tipo: "Criança", contato: "(21) 99905-6614", data: "18/10/2026", idade: 10},
  {responsavel: "FAMILIA HENRIQUE", nome: "ALAN HENRIQUE", tipo: "Adulto", contato: "(21) 97666-2100", data: "20/10/2026", idade: 27},
  {responsavel: "FAMILIA HENRIQUE", nome: "JULIA HENRIQUE", tipo: "Adulto", contato: "(21) 97666-2100", data: "20/10/2026", idade: 26},
  {responsavel: "FAMILIA IVO", nome: "RAFAEL IVO", tipo: "Adulto", contato: "(22) 99631-5509", data: "22/10/2026", idade: 35},
  {responsavel: "FAMILIA IVO", nome: "BRENDA IVO", tipo: "Adulto", contato: "(22) 99631-5509", data: "22/10/2026", idade: 34},
  {responsavel: "FAMILIA IVO", nome: "GABRIEL IVO", tipo: "Criança", contato: "(22) 99631-5509", data: "22/10/2026", idade: 8},
  {responsavel: "FAMILIA JUNQUEIRA", nome: "OTAVIO JUNQUEIRA", tipo: "Adulto", contato: "(21) 98224-1900", data: "24/10/2026", idade: 44},
  {responsavel: "FAMILIA JUNQUEIRA", nome: "MIRELA JUNQUEIRA", tipo: "Adulto", contato: "(21) 98224-1900", data: "24/10/2026", idade: 40},
  {responsavel: "FAMILIA JUNQUEIRA", nome: "LUANA JUNQUEIRA", tipo: "Criança", contato: "(21) 98224-1900", data: "24/10/2026", idade: 12}
];

const TAREFAS_INICIAIS = [
  {id: 1, titulo: "Confirmar buffet", descricao: "Ligar para confirmar o cardápio e horário", categoria: "Decoração", concluida: false},
  {id: 2, titulo: "Comprar flores", descricao: "Arranjos para as mesas principais", categoria: "Decoração", concluida: false},
  {id: 3, titulo: "Preparar centro de mesa", descricao: "10 centros de mesa com flores", categoria: "Decoração", concluida: true},
  {id: 4, titulo: "Confirmar DJ", descricao: "Verificar equipamento de som", categoria: "Festa", concluida: false},
  {id: 5, titulo: "Enviar convites", descricao: "Confirmar endereço de todos os convidados", categoria: "Festa", concluida: true}
];

export const EventosProvider = ({ children }) => {
  const [nomeUsuario, setNomeUsuario] = useState(() => {
    return localStorage.getItem('nomeUsuario') || '';
  });

  const [eventos, setEventos] = useState(() => {
    const saved = localStorage.getItem('eventos');
    return saved ? JSON.parse(saved) : [];
  });

  const [eventoAtual, setEventoAtual] = useState(() => {
    return localStorage.getItem('eventoAtual') || null;
  });

  const [dadosEvento, setDadosEvento] = useState(() => {
    if (eventoAtual) {
      const saved = localStorage.getItem(`evento_${eventoAtual}`);
      if (saved) return JSON.parse(saved);
    }
    return {
      convidados: CONVIDADOS_INICIAIS,
      tarefas: TAREFAS_INICIAIS,
      cronograma: [],
      mesas: []
    };
  });

  // Salvar no localStorage quando houver mudanças
  useEffect(() => {
    if (nomeUsuario) {
      localStorage.setItem('nomeUsuario', nomeUsuario);
    }
  }, [nomeUsuario]);

  useEffect(() => {
    localStorage.setItem('eventos', JSON.stringify(eventos));
  }, [eventos]);

  useEffect(() => {
    if (eventoAtual) {
      localStorage.setItem('eventoAtual', eventoAtual);
    }
  }, [eventoAtual]);

  useEffect(() => {
    if (eventoAtual) {
      localStorage.setItem(`evento_${eventoAtual}`, JSON.stringify(dadosEvento));
    }
  }, [dadosEvento, eventoAtual]);

  const criarEvento = (nome) => {
    const novoEvento = {
      id: Date.now(),
      nome,
      dataCriacao: new Date().toISOString()
    };
    setEventos([...eventos, novoEvento]);
    return novoEvento;
  };

  const excluirEvento = (id) => {
    setEventos(eventos.filter(e => e.id !== id));
    localStorage.removeItem(`evento_${id}`);
    if (eventoAtual === id) {
      setEventoAtual(null);
    }
  };

  const selecionarEvento = (id) => {
    setEventoAtual(id);
    const saved = localStorage.getItem(`evento_${id}`);
    if (saved) {
      setDadosEvento(JSON.parse(saved));
    } else {
      setDadosEvento({
        convidados: CONVIDADOS_INICIAIS,
        tarefas: TAREFAS_INICIAIS,
        cronograma: [],
        mesas: []
      });
    }
  };

  const desselecionarEvento = () => {
    setEventoAtual(null);
    localStorage.removeItem('eventoAtual');
  };

  const atualizarDadosEvento = (novosDados) => {
    setDadosEvento(novosDados);
  };

  return (
    <EventosContext.Provider value={{
      nomeUsuario,
      setNomeUsuario,
      eventos,
      eventoAtual,
      dadosEvento,
      criarEvento,
      excluirEvento,
      selecionarEvento,
      desselecionarEvento,
      atualizarDadosEvento
    }}>
      {children}
    </EventosContext.Provider>
  );
};

export const useEventos = () => {
  const context = useContext(EventosContext);
  if (!context) {
    throw new Error('useEventos deve ser usado dentro de EventosProvider');
  }
  return context;
};